import { render, staticRenderFns } from "./ListContracts.vue?vue&type=template&id=edb793d2"
import script from "./ListContracts.vue?vue&type=script&lang=js"
export * from "./ListContracts.vue?vue&type=script&lang=js"
import style0 from "./ListContracts.vue?vue&type=style&index=0&id=edb793d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports